// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1mUmX","label":"Radio_label__3p6o8","checkMark":"Radio_checkMark__3vJVE","disabled":"Radio_disabled__1SorX"};